import { render, staticRenderFns } from "./TypedText.vue?vue&type=template&id=1ced650b&scoped=true"
import script from "./TypedText.vue?vue&type=script&lang=js"
export * from "./TypedText.vue?vue&type=script&lang=js"
import style0 from "./TypedText.vue?vue&type=style&index=0&id=1ced650b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ced650b",
  null
  
)

export default component.exports